// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","304":"component---src-pages-units-start-getting-started-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"8166e872e083c6d1870d","304":"4709ce7ee61fe3559f57","453":"374ec30576fb22ab5c4a"}[chunkId] + ".js";
};